import { render, staticRenderFns } from "./purchaseContractApproval.vue?vue&type=template&id=1e788914"
import script from "./purchaseContractApproval.vue?vue&type=script&lang=js"
export * from "./purchaseContractApproval.vue?vue&type=script&lang=js"
import style0 from "./purchaseContractApproval.vue?vue&type=style&index=0&id=1e788914&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports